import api from "@/api.js";

export default {
  namespaced: true,
  modules: {},
  state: {
    list: [],
    listLoading: false,
    current: null,
    currentLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("pageHelp");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setCurrentLoading", true);
      let list = await api.get("pageHelp/byID", { params: { id: id } });
      commit("setCurrent", list.data[0]);
      commit("setCurrentLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("pageHelp", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`pageHelp`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
  },
};
